import { AnalystChartSpec, AnalystTableSpec } from '@digital-twins/shared-types'

import { FeaturedAnalystChart } from './FeaturedAnalystChart'
import { FeaturedAnalystTable } from './FeaturedAnalystTable'

interface ThreadFeaturedExhibitsProps {
  charts?: Array<AnalystChartSpec>
  tables?: Array<AnalystTableSpec>
}

export function ThreadFeaturedExhibits(props: ThreadFeaturedExhibitsProps) {
  const { charts = [] } = props
  const tables = tablesNotCharted(props.tables ?? [], charts)

  if (charts.length === 0 && tables.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4" data-testid="thread-featured-exhibits">
      {tables.map((table, index) => (
        <FeaturedAnalystTable
          key={`${table.title}-${index}`}
          table={table}
          index={index}
        />
      ))}
      {charts.map((chart, index) => (
        <FeaturedAnalystChart
          key={`${chart.title}-${index}`}
          chart={chart}
          index={index}
        />
      ))}
    </div>
  )
}

// A table whose every cell is a figure some chart already draws repeats that
// chart, so the thread shows the chart alone.
export function tablesNotCharted(
  tables: Array<AnalystTableSpec>,
  charts: Array<AnalystChartSpec>,
): Array<AnalystTableSpec> {
  const charted = new Set(charts.flatMap((chart) => chart.evidenceFactIds ?? []))
  if (charted.size === 0) {
    return tables
  }
  return tables.filter((table) => {
    const factIds = (table.rows ?? []).flatMap((row) =>
      (row.cells ?? []).map((cell) => cell.evidenceFactId),
    )
    return factIds.length === 0 || !factIds.every((factId) => factId && charted.has(factId))
  })
}

export function asAnalystCharts(value: unknown): Array<AnalystChartSpec> | undefined {
  if (!Array.isArray(value) || value.length === 0) {
    return undefined
  }
  return value as Array<AnalystChartSpec>
}

export function asAnalystTables(value: unknown): Array<AnalystTableSpec> | undefined {
  if (!Array.isArray(value) || value.length === 0) {
    return undefined
  }
  return value as Array<AnalystTableSpec>
}
